import type { HttpPort } from "~/lib/http";
import type { TeacherClass } from "./classes";

export interface TeamPerson {
  id: string;
  first_name: string;
  last_name: string;
}

export interface TakeoverRequest extends TeamPerson {
  id: string;
  requested_by: string;
  created_at: string;
}

export interface ClassTeam {
  editor: TeamPerson;
  readers: TeamPerson[];
  requests: TakeoverRequest[];
  myRequestPending: boolean;
}

// Mitlesende Lehrkräfte sehen die Klasse nur; bearbeiten darf genau eine Lehrkraft (access_level "edit").
export function isReadOnly(value: Pick<TeacherClass, "access_level"> | undefined) {
  return value?.access_level === "read";
}

export function personName(person: Pick<TeamPerson, "first_name" | "last_name">) {
  return `${person.first_name} ${person.last_name}`.trim();
}

export function createClassTeamModule(http: HttpPort, token: string) {
  const base = (classId: string) => `/class-team/${encodeURIComponent(classId)}`;
  return {
    get: (classId: string) => http.request<ClassTeam>({ path: base(classId), token }),
    handOver: (classId: string, userId: string) => http.request<{ success: boolean }>({ path: `${base(classId)}/handover`, method: "POST", token, body: { userId } }),
    requestTakeover: (classId: string) => http.request<{ id: string }>({ path: `${base(classId)}/takeover-requests`, method: "POST", token, body: {} }),
    decide: (classId: string, requestId: string, accept: boolean) =>
      http.request<{ success: boolean }>({ path: `${base(classId)}/takeover-requests/${encodeURIComponent(requestId)}/${accept ? "accept" : "decline"}`, method: "POST", token, body: {} })
  };
}

export type ClassTeamModule = ReturnType<typeof createClassTeamModule>;
